<template>
  <div :class="$style.container">
    <button
      :class="$style.closeButton"
      @click="handleClose"
    >
      <img
        :class="$style.closeButtonImg"
        src="img/icons/close_modal.svg"
      >
    </button>
    <h2
      v-if="header"
      :class="$style.header"
    >
      {{ header }}
    </h2>
    <div
      v-if="showTabs"
      :class="$style.tabContainer"
    >
      <div
        v-for="(video, index) in videos"
        :key="index"
        :class="[$style.tab, {
          [$style.activeTab]: currentVideo.tabName === videos[index].tabName,
        }]"
        @click="() => currentVideo = videos[index]"
      >
        {{ videos[index].tabName }}
      </div>
    </div>
    <div
      :class="[$style.videoContainer, {
        [$style.videoContainerMarginTop]: !header && !showTabs,
      }]"
    >
      <WistiaVideo
        v-show="currentVideo.iframeUrl"
        :autoPlay="autoPlay"
        :videoUrl="currentVideo.iframeUrl"
      />
    </div>
    <div>
      <div
        :class="$style.urlText"
      >
        <a
          :href="currentVideo.videoUrl"
          rel="noopener noreferrer"
          target="_blank"
          @click="openInNewTabClicked"
        >
          {{ openInNewTabText }}
        </a>
      </div>
      <div
        v-if="currentVideo.kbLinkObject"
        :class="$style.buttonContainer"
      >
        <a
          :class="$style.externalLink"
          :href="currentVideo.kbLinkObject.url"
          target="_blank"
          @click="currentVideo.kbLinkObject.action"
        >
          {{ currentVideo.kbLinkObject.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import WistiaVideo from 'client/GrowthEngineering/components/WistiaVideo.vue';

export default {
  name: 'VideoModal',

  components: {
    WistiaVideo,
  },

  props: {
    autoPlay: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: '',
    },
    modalClosedAction: {
      type: Function,
      default: () => {},
    },
    openAtTab: {
      type: String,
      default: '',
    },
    videos: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    currentVideo: {},
    openInNewTabText: 'Open video in new tab',
  }),

  computed: {
    showTabs() {
      return this.videos.length > 1;
    },
  },

  created() {
    if (this.openAtTab) {
      this.currentVideo = this.videos.find(video => video.tabName === this.openAtTab)
        || this.videos[0];
    } else {
      [this.currentVideo] = this.videos;
    }
  },

  methods: {
    handleClose() {
      this.modalClosedAction();
      ModalEventBus.close();
    },
    openInNewTabClicked() {
      EventHelper.triggerVideoModalLinkClicked({
        text: this.openInNewTabText,
        url: this.currentVideo.videoUrl,
      });
    },
  },
};
</script>

<style module>
@value (
  gradientDark1,
  gradientDark2,
  gradientLight3,
  jcGreen,
  white
) from '~css/colors.css';

button.closeButton,
button.closeButton:focus,
button.closeButton:hover {
  background-color: inherit;
  border: 0;
  cursor: pointer;
  outline: none;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 10px;
}

.buttonContainer {
  float: right;
  margin: 10px 20px;
  text-align: right;
}

.closeButtonImg {
  background-color: inherit;
  border-radius: 50%;
  width: 45px;
}

.closeButtonImg:hover {
  background-color: gradientLight3;
}

.externalLink {
  display: inline-block;
  text-align: right;
  text-decoration: underline;
  vertical-align: middle;
}

.tab {
  color: gradientDark2;
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  margin-right: 30px;
}

.tab:hover { color: gradientDark1; }

.activeTab {
  border-bottom: 3px solid var(--jcPrimary);
  color: gradientDark1;
}

.tabContainer {
  margin-left: 20px;
  margin-top: 20px;
}

.urlText {
  cursor: pointer;
  float: left;
  font-weight: 400;
  margin: 10px 20px;
}

.videoContainer {
  display: inline-block;
  margin-top: 20px;
  width: 100%;
}

.videoContainerMarginTop {
  margin-top: 60px;
}

.container .header {
  font-size: 24px;
  font-weight: 800;
  margin-left: 20px;
}
</style>
